import StepSettings from './StepSettings.component';

export default StepSettings;
